<div class="row shadow title-list bg-white rounded">
  <div class="col-lg-2 pl-5 pt-2">
    <h1 class="lblTitle-02">
      {{ 'binnacle.lblTitle' | translate }}
    </h1>
  </div>

  <div class="col-lg-10">
    <div class="row">
      <div class="col-lg-2 col-md-3 col-sm-12">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>
            {{ 'common.filters.txtCreationDate' | translate }}
          </mat-label>
          <mat-date-range-input [rangePicker]="txtFechaAlta" [max]="todayDate">
            <input matStartDate placeholder="Fecha inicio" [formControl]="f.txtDateInit"
              (ngModelChange)="modelChanged($event,'txtDateInit')">
            <input matEndDate placeholder="Fecha fin" [formControl]="f.txtDateEnd" id="txtDateEnd"
              (ngModelChange)="modelChanged($event,'txtDateEnd')">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
          <mat-date-range-picker #txtFechaAlta>
          </mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="col-lg-2 col-md-3 col-sm-12" [class.d-none]="!this.showDdlCompany">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>{{ 'common.filters.ddlCompany' | translate }}</mat-label>
          <mat-select [formControl]="f.ddlCompany" (selectionChange)="onChangeCompany($event)">
            <mat-option *ngFor="let item of this.catCompany" value="{{item.companyId.toString()}}">
              {{item.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-12">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>
            {{ 'common.filters.txtBranch' | translate }}
          </mat-label>
          <mat-select [formControl]="f.ddlBranch" (selectionChange)="onChangeBranch($event)">
            <mat-option *ngFor="let item of this.catBranches" value="{{item.id.toString()}}">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-2 col-md-3 col-sm-12">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>
            {{ 'common.filters.txtUser' | translate }}
          </mat-label>
          <mat-select [formControl]="f.ddlUser">
            <mat-option *ngFor="let item of this.catUsers" value="{{item.id.toString()}}">{{item.username}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>


      <div class="col-lg-3">
        <div class="btn-group">
          <button type="button" class="btn-none mb-2" (click)="acc.toggle('toggle-1')">
            <mat-icon>tune</mat-icon>
          </button>

          <button type="button" class="btn btn-primary m-b-10 mr-2 mb-2 w-100-px" (click)="searchInfo()">
            <div class="flex justify-all-center">
              <mat-icon>search</mat-icon>
              {{ 'common.btnSearch' | translate }}
            </div>
          </button>

          <button type="button" class="btn btn-secondary m-b-10 mb-2 w-100-px" (click)="removeFilter()">
            <i class="fas fa-times mr-1"></i>
            {{ 'common.btnClear' | translate }}
          </button>

        </div>
      </div>
    </div>

    <ngb-accordion #acc="ngbAccordion">
      <ngb-panel id="toggle-1" title="">
        <ng-template ngbPanelContent>
          <div class="row">

            <div class="col-lg-2 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>
                  {{ 'common.filters.txtStatus' | translate }}
                </mat-label>
                <mat-select [formControl]="f.ddlStatus">
                  <mat-option *ngFor="let item of this.catStatus"
                    value="{{item.id.toString()}}">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>
                  {{ 'common.filters.ddlSource' | translate }}
                </mat-label>
                <mat-select [formControl]="f.ddlOrigin">
                  <mat-option *ngFor="let item of this.catOrigin"
                    value="{{item.id.toString()}}">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-12 ">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>
                  {{ 'common.filters.txtName' | translate }}
                </mat-label>
                <button class="btn-serch-field"><mat-icon>search</mat-icon></button>
                <input type="text" matInput maxlength="150" [formControl]="f.txtFullName" autocomplete="off" />
              </mat-form-field>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>
                  {{ 'common.filters.ddlLogType' | translate }}
                </mat-label>
                <mat-select [formControl]="f.ddlLogType">
                  <mat-option *ngFor="let item of this.catLogType"
                    value="{{item.key.toString()}}">{{item.description}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>

<div class="container-fluid mb-3">
  <div class="row">
    <div class="content-wrap px-5">
      <div class="container-header-table">
        <div class="text-right">
          <div class="btn-group">
            <button type="button" class="btn btn-download mr-2 mb-2" (click)="onExportPDF()">
              {{'common.download' | translate}} PDF
            </button>

            <button type="button" class="btn btn-download mb-2" (click)="onExportExcel()">
              {{'common.download' | translate}} EXCEL
            </button>
          </div>
        </div>
      </div>

      <table class="table-class-responsive" aria-describedby="Tabla de bitacora">
        <thead class="table-container-header-fijo-responsive">
          <tr>
            <th class="column-title-responsive w-10-p">{{ 'binnacle.gridColumns.IdOperation' | translate
              }}</th>
            <th class="column-title-responsive w-10-p">{{ 'binnacle.gridColumns.IP' | translate }}</th>
            <th class="column-title-responsive w-15-p">{{ 'binnacle.gridColumns.BranchName' | translate }}
            </th>
            <th class="column-title-responsive w-20-p">{{ 'binnacle.gridColumns.ClientName' | translate }}
            </th>
            <th class="column-title-responsive w-15-p">{{ 'binnacle.gridColumns.Source' | translate }}
            </th>
            <th class="column-title-responsive w-15-p">{{ 'binnacle.gridColumns.EnrollmentStatus' |
              translate }}</th>
            <th class="column-title-responsive w-15-p">{{ 'binnacle.gridColumns.UserCreate' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>

          <tr></tr>

          <ng-container *ngFor="let data of dataInformation">

            <tr class="row-table-responsive">
              <td class="w-10-p">
                <div class="row-table-body-responsive flex">
                  <button *ngIf="data.hasEnrollData || data.hasValidationData" class="btn-none mr-1"
                    id="btn_{{ data.id}}" (click)="onShowTableChild(data.id)">
                    <i id="icon_{{ data.id}}" class="fa-solid fa-angle-down"></i>
                  </button>
                  <div>{{ data.id }}</div>
                </div>
              </td>
              <td class="row-table-body-responsive w-10-p txt-align-center">{{ data.ip }}</td>
              <td class="row-table-body-responsive w-15-p txt-align-center">{{ data.branch.name }}
              </td>
              <td class="row-table-body-responsive w-20-p txt-align-center">{{ data.firstName + " " +
                data.fatherSurname + " " + data.motherSurname }}</td>
              <td class="row-table-body-responsive w-15-p txt-align-center">{{ data.originDescription
                }}</td>
              <td class="row-table-body-responsive w-15-p txt-align-center">
                <span class="td-value-row" *ngIf="data.status == 1 ">
                  {{ 'dashboard.catStatus.Success' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 2 ">
                  {{ 'dashboard.catStatus.InReview' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 3 ">
                  {{ 'dashboard.catStatus.Reject' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 0 ">
                  {{ 'dashboard.catStatus.NA' | translate }}
                </span>
              </td>
              <td class="row-table-body-responsive w-15-p txt-align-center">{{ data.user.name }}</td>
            </tr>

            <tr>
              <!-- START Enroll Data table, how time the user stay in this section -->
              <td colspan="7" class="p-0-px">

                <ng-container *ngIf="data.hasEnrollData">
            <tr>
              <td class="pl-15-px border-none">{{'common.enrollment.sectionName' | translate |
                uppercase}}</td>
            </tr>

            <div class="table-container-responsive table-container-subtable-responsive h-auto">
              <div class="table-frame-responsive">
                <table class="table-class-responsive" id="tbl_{{ data.id}}" aria-describedby="Tabla de enrolamiento">
                  <thead class="table-container-header-fijo-responsive z-index-0">
                    <tr>
                      <th class="column-title-responsive column-title-subtable-responsive w-15-p">
                        {{ 'binnacle.gridColumns.Id' | translate }}
                      </th>
                      <th class="column-title-responsive column-title-subtable-responsive w-15-p">
                        {{ 'binnacle.gridColumns.Start' | translate }}
                      </th>
                      <th class="column-title-responsive column-title-subtable-responsive w-15-p">
                        {{ 'binnacle.gridColumns.End' | translate }}
                      </th>
                      <th class="column-title-responsive column-title-subtable-responsive w-15-p">
                        {{ 'binnacle.gridColumns.Duration' | translate }}
                      </th>
                      <th class="column-title-responsive column-title-subtable-responsive w-20-p">
                        {{ 'binnacle.gridColumns.Action' | translate }}
                      </th>
                      <th class="column-title-responsive column-title-subtable-responsive w-20-p">
                        {{ 'binnacle.gridColumns.ExternalClientId' | translate }}
                      </th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>

                    <ng-container *ngFor="let _enrollData of data.enrollData">
                      <tr class="row-table-subtable-responsive">
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-15-p">
                          {{ _enrollData.id }}</td>
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-15-p">
                          {{ _enrollData.startDate }}</td>
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-15-p">
                          {{ _enrollData.endDate }}</td>
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-15-p">
                          {{ _enrollData.duration }}</td>
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-20-p">
                          {{ _enrollData.description }}</td>
                        <td class="row-table-body-responsive row-table-body-subtable-responsive w-20-p">
                          {{ _enrollData.externalClientId }}</td>
                      </tr>
                    </ng-container>

                  </tbody>
                </table>
              </div>
            </div>

          </ng-container>


          </td>
          <!-- END Enroll Data table, how time the user stay in this section -->

          </tr>

          <tr>
            <!-- START Inf of validations, how time the user stay in this section -->
            <td colspan="7" class="p-0-px">

              <ng-container *ngIf="data.hasValidationData">
          <tr>
            <td class="pl-15-px border-none">{{'common.validations.sectionName' | translate | uppercase}}
            </td>
          </tr>

          <div class="table-container-responsive table-container-subtable-responsive h-auto">
            <div class="table-frame-responsive">
              <table class="table-class-responsive" id="tbl2_{{ data.id}}"
                aria-describedby="Tabla de info de validaciones">
                <thead class="table-container-header-fijo-responsive z-index-0">
                  <tr>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.Id' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.Start' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.End' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.Duration' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-20-p">
                      {{ 'binnacle.gridColumns.Action' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.ExternalClientId' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-20-p">
                      {{ 'binnacle.gridColumns.User' | translate }}
                    </th>
                    <th class="column-title-responsive column-title-subtable-responsive w-10-p">
                      {{ 'binnacle.gridColumns.ValidationStatus' | translate }}
                    </th>

                  </tr>

                </thead>
                <tbody>
                  <tr></tr>

                  <ng-container *ngFor="let _enrollData of data.validationData">
                    <tr class="row-table-subtable-responsive">
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.id }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.startDate }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.endDate }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.duration }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-20-p">{{
                        _enrollData.description }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.externalClientId }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-20-p">{{
                        _enrollData.userName }}</td>
                      <td class="row-table-body-responsive row-table-body-subtable-responsive w-10-p">{{
                        _enrollData.status }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>

          </ng-container>


          </td>
          <!-- END Inf of validations, how time the user stay in this section -->

          </tr>

          </ng-container>

          <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
            <td colspan="9" class="mt-3 h-360-px justify-all-center">
              <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
              <br>
              <span class="text-info-gray fw-w-bold">{{ msgDataEmpty }}</span>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="row mt-1 mr-5">
  <div class="col-md-12 mb-5 d-flex justify-content-end">
    <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
      (changePage)="changePage($event)"></app-pagination-table>
  </div>
</div>